<template>
	<b-col cols="6">
		<h4 class="mt-2">Ability Scores</h4>
		<b-table-simple resposnive small bordered striped table-class="mb-0">
			<b-tbody>
				<b-tr>
					<b-td><strong>STR</strong> <small class="text-muted">Strength</small></b-td>
					<b-td class="text-right">{{abilityScores["Strength"]}}</b-td>
					<b-td class="text-right">{{abilityMods["Strength"]|bonus}}</b-td>
					<b-td><strong>DEX</strong> <small class="text-muted">Dexterity</small></b-td>
					<b-td class="text-right">{{abilityScores["Dexterity"]}}</b-td>
					<b-td class="text-right">{{abilityMods["Dexterity"]|bonus}}</b-td>
				</b-tr>
				<b-tr>
					<b-td><strong>CON</strong> <small class="text-muted">Constitution</small></b-td>
					<b-td class="text-right">{{abilityScores["Constitution"]}}</b-td>
					<b-td class="text-right">{{abilityMods["Constitution"]|bonus}}</b-td>
					<b-td><strong>INT</strong> <small class="text-muted">Intelligence</small></b-td>
					<b-td class="text-right">{{abilityScores["Intelligence"]}}</b-td>
					<b-td class="text-right">{{abilityMods["Intelligence"]|bonus}}</b-td>
				</b-tr>
				<b-tr>
					<b-td><strong>WIS</strong> <small class="text-muted">Wisdom</small></b-td>
					<b-td class="text-right">{{abilityScores["Wisdom"]}}</b-td>
					<b-td class="text-right">{{abilityMods["Wisdom"]|bonus}}</b-td>
					<b-td><strong>CHA</strong> <small class="text-muted">Charisma</small></b-td>
					<b-td class="text-right">{{abilityScores["Charisma"]}}</b-td>
					<b-td class="text-right">{{abilityMods["Charisma"]|bonus}}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-col>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		...mapGetters('character/abilityScores',[
			'abilityScores',
			'abilityMods',
		]),
	},
}
</script>

<style scoped>

</style>